// src/pages/ContactUs.jsx
import React from "react";
import innerBanner from "../Images/inner-banner-image.jpg";
import Footer from "../Components/Footer";
import { useRef } from "react";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_60y60rg", "template_hk0pm8a", form.current, {
        publicKey: "xahhGGlABhjCzqyZz",
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <div>
      <div className="inner-banner-section">
        <img src={innerBanner} alt="inner-banner" />
        <div className="inner-banner-heading">
          <span>Contact Us</span>
        </div>
      </div>
      {/* ----------------------------------------- */}

      <div className="contact-page-section">
        <div className="container">
          <div className="contact-page-content">
            <h1>Marketing and Customer care</h1>
            <p>
              We provide to every customer full value for the money he pays.
              Technically sound and energetic marketing team is ready at your
              door step to accept your bulk orders and deliver in time. We
              meticulously follow well known norms in marketing namely Quality.
              Price, on time Delivery and Customer Satisfaction.
            </p>
            <div className="contact-form-section">
              <div className="contact-form-left">
                <h3>Enquiry Form</h3>
                <div className="contact-from">
                  <form ref={form} onSubmit={sendEmail}>
                    <label>Name</label>
                    <input type="text" name="user_name" required />
                    <label>Mobile Number</label>
                    <input type="number" name="mobile_number" min={10} max={10} />
                    <label>Email</label>
                    <input type="email" name="user_email" />
                    <label>Message</label>
                    <textarea name="message" />
                    <input type="submit" value="Send" />
                  </form>
                </div>
              </div>
              <div className="contact-form-right">
                <h3>Contact Details</h3>
                <p>
                  Mr Madhan, Admin Manager <br />
                  <a href="tel:+91 94878 11417">+91 94878 11417</a>
                  <br />
                  <a href="mailto:ssfyarns@gmail.com">ssfyarns@gmail.com</a>
                </p>
                <br />
                <h3>Address</h3>
                <p>
                  R-12. Sipcot Industrial Growth Centre,<br/>
                   Perundurai - 638 052,<br/>
                  Erode District, Tamilnadu.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------------------------- */}

      {/* ---------------------------------------- */}
      <Footer />
    </div>
  );
};

export default ContactUs;
